import { render, staticRenderFns } from "./themePc.vue?vue&type=template&id=68d149fa&scoped=true"
import script from "./themePc.vue?vue&type=script&lang=js"
export * from "./themePc.vue?vue&type=script&lang=js"
import style0 from "./themePc.vue?vue&type=style&index=0&id=68d149fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d149fa",
  null
  
)

export default component.exports